(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muurverfwinkel-assortiment"] && !Shopify.designMode) return;
  try {
    
  Promise.all([import('@theme/component'), import('@theme/utilities'), import('@theme/scroll-container')]).then(([{ Component }, { lockScroll, unlockScroll, isClickedOutside }, { getScrollTop, scrollTo }]) => {
    class MwPaintAssortment extends Component {
      #controller;
      #selectionTimers = new Map();
      #fragmentFrame;
      #fragmentRequest = 0;
      #fragmentTransition;
      #fragmentHandledHash;
      #fragmentInterrupted = false;
      #activeDialog;
      #dialogContent;
      #dialogDetails;
      #dialogReturnFocus;
      #dialogScrollTop = 0;
      #failedDialogs = new WeakSet();

      connectedCallback() {
        super.connectedCallback();
        this.#closeProduct(false, false);
        this.#controller?.abort();
        this.#clearSelectionAnnouncements();
        this.#cancelFragmentNavigation();
        this.#fragmentTransition = undefined;
        this.#controller = new AbortController();
        const { signal } = this.#controller;
        this.#restorePlan();
        this.#restoreWallDimensions();
        this.#updateSelectionSummaries();
        this.#updateFilterStatus();
        this.#syncMediaControls();
        this.addEventListener('toggle', this.#handleDetailsToggle, { signal, capture: true });
        this.addEventListener('close', this.#handleDialogClose, { signal, capture: true });
        this.addEventListener('input', this.#handleInput, { signal });
        this.addEventListener('change', this.#handleInput, { signal });
        this.addEventListener('click', this.#handleClick, { signal });
        this.addEventListener('keydown', this.#handleKeydown, { signal });
        window.addEventListener('hashchange', this.#handleFragmentNavigation, { signal });
        window.addEventListener('pageshow', this.#handleFragmentNavigation, { signal });
        window.addEventListener('pagereveal', this.#captureFragmentTransition, { signal });
        window.addEventListener('pagehide', this.#handlePageHide, { signal });
        document.addEventListener('pointerdown', this.#cancelFragmentNavigation, { signal, capture: true });
        document.addEventListener('keydown', this.#cancelFragmentNavigation, { signal, capture: true });
        document.addEventListener('wheel', this.#cancelFragmentNavigation, { signal, capture: true, passive: true });
        this.#scheduleFragmentNavigation();
      }

      disconnectedCallback() {
        this.#closeProduct(false, false);
        this.#clearSelectionAnnouncements();
        this.#cancelFragmentNavigation();
        this.#fragmentTransition = undefined;
        this.#controller?.abort();
        super.disconnectedCallback();
      }

      updatedCallback() {
        super.updatedCallback();
        this.#closeProduct(false, false);
        this.#clearSelectionAnnouncements();
        this.#restorePlan();
        this.#restoreWallDimensions();
        this.#updateSelectionSummaries();
        this.#updateFilterStatus();
        this.#syncMediaControls();
        this.#scheduleFragmentNavigation();
      }

      #restorePlan() {
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.dataset.storageKey) || '{}');
          if (!saved || typeof saved !== 'object' || Array.isArray(saved)) return;
          for (const input of this.querySelectorAll('[data-save-colour], [data-save-plan]')) {
            if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) continue;
            const value = saved[input.dataset.storageName || input.name];
            if (typeof value !== 'string') continue;
            if (input instanceof HTMLInputElement && input.type === 'radio') input.checked = input.value === value;
            else if (input instanceof HTMLSelectElement) {
              if ([...input.options].some((option) => option.value === value)) input.value = value;
            } else input.value = value;
          }
        } catch {}
        for (const group of this.querySelectorAll('.mw-paint-colour')) this.#syncQuickChoices(group);
      }

      #restoreWallDimensions() {
        for (const group of this.querySelectorAll('[data-calculator]')) {
          const state = group.querySelector('[data-wall-state]');
          const rows = group.querySelector('[data-wall-rows]');
          if (!(state instanceof HTMLInputElement) || !(rows instanceof HTMLElement)) continue;
          let walls = [{ length: '', height: '' }];
          try {
            const saved = state.value.length <= 5000 ? JSON.parse(state.value || 'null') : null;
            if (Array.isArray(saved) && saved.length) walls = saved.slice(0, 10).map((wall) => ({ length: typeof wall?.length === 'string' && wall.length.length <= 12 ? wall.length : '', height: typeof wall?.height === 'string' && wall.height.length <= 12 ? wall.height : '' }));
          } catch {}
          rows.replaceChildren();
          group.dataset.nextWallIndex = '0';
          for (const wall of walls) this.#appendWallRow(group, wall);
          if (!(group.querySelector('[data-area-mode]:checked') instanceof HTMLInputElement)) {
            const manual = group.querySelector('[data-area-mode][value="manual"]');
            if (manual instanceof HTMLInputElement) manual.checked = true;
          }
          this.#syncWallState(group);
        }
      }

      #appendWallRow(group, values = {}) {
        const template = group.querySelector('template[data-wall-template]');
        const rows = group.querySelector('[data-wall-rows]');
        if (!(template instanceof HTMLTemplateElement) || !(rows instanceof HTMLElement) || rows.children.length >= 10) return;
        const row = template.content.firstElementChild?.cloneNode(true);
        if (!(row instanceof HTMLElement)) return;
        const index = Number(group.dataset.nextWallIndex || 0) + 1;
        group.dataset.nextWallIndex = String(index);
        for (const key of ['length', 'height']) {
          const input = row.querySelector(`[data-wall-${key}]`);
          const label = row.querySelector(`[data-wall-${key}-label]`);
          if (!(input instanceof HTMLInputElement) || !(label instanceof HTMLLabelElement)) continue;
          input.id = `${group.dataset.wallPrefix}-${key}-${index}`;
          input.name = input.id;
          input.value = typeof values[key] === 'string' ? values[key] : '';
          label.htmlFor = input.id;
        }
        rows.append(row);
        return row;
      }

      #syncWallState(group) {
        const rows = [...group.querySelectorAll('[data-wall-row]')];
        const values = rows.map((row, index) => {
          const label = row.querySelector('[data-wall-label]');
          if (label instanceof HTMLElement) label.textContent = (group.dataset.wallLabel || '').replaceAll('[number]', String(index + 1));
          const remove = row.querySelector('[data-remove-wall]');
          if (remove instanceof HTMLButtonElement) {
            remove.disabled = rows.length <= 1;
            remove.setAttribute('aria-label', (group.dataset.wallRemoveLabel || '').replaceAll('[number]', String(index + 1)));
          }
          return { length: row.querySelector('[data-wall-length]')?.value || '', height: row.querySelector('[data-wall-height]')?.value || '' };
        });
        const state = group.querySelector('[data-wall-state]');
        if (state instanceof HTMLInputElement) state.value = JSON.stringify(values);
        const add = group.querySelector('[data-add-wall]');
        if (add instanceof HTMLButtonElement) add.disabled = rows.length >= 10;
      }

      #clearCalculation(group) {
        for (const invalid of group.querySelectorAll('[aria-invalid]')) invalid.removeAttribute('aria-invalid');
        const status = group.querySelector('[data-calc-status]');
        if (status instanceof HTMLElement) { status.textContent = ''; delete status.dataset.state; }
        const net = group.querySelector('[data-wall-net]');
        if (net instanceof HTMLElement) { net.textContent = ''; net.hidden = true; }
      }

      #prepareWallArea(group) {
        if (!group.querySelector('[data-area-mode][value="dimensions"]:checked')) return true;
        let gross = 0;
        const rows = [...group.querySelectorAll('[data-wall-row]')];
        for (const row of rows) {
          const length = row.querySelector('[data-wall-length]');
          const height = row.querySelector('[data-wall-height]');
          for (const input of [length, height]) {
            if (!(input instanceof HTMLInputElement)) return false;
            const parsed = this.#parseArea(input.value);
            if (parsed.error) {
              this.#setFeedback(group, '[data-calc-status]', parsed.error === 'ambiguous' ? group.dataset.errorAmbiguous || '' : group.dataset.errorDimensions || '', input);
              return false;
            }
          }
          gross += this.#parseArea(length.value).value * this.#parseArea(height.value).value;
        }
        const deduction = group.querySelector('[data-wall-deduction]');
        if (!(deduction instanceof HTMLInputElement)) return false;
        const raw = deduction.value.trim();
        const parsedDeduction = raw === '' || /^(?:0+(?:[.,]0+)?|[.,]0+)$/.test(raw) ? { value: 0, error: '' } : this.#parseArea(raw);
        if (parsedDeduction.error) {
          this.#setFeedback(group, '[data-calc-status]', parsedDeduction.error === 'ambiguous' ? group.dataset.errorAmbiguous || '' : group.dataset.errorDeduction || '', deduction);
          return false;
        }
        const net = gross - parsedDeduction.value;
        if (!Number.isFinite(gross) || !Number.isFinite(net) || gross <= 0) {
          this.#setFeedback(group, '[data-calc-status]', group.dataset.errorDimensions || '', rows[0]?.querySelector('[data-wall-length]'));
          return false;
        }
        if (net <= 0) {
          this.#setFeedback(group, '[data-calc-status]', group.dataset.errorNet || '', deduction);
          return false;
        }
        const area = group.querySelector('[data-calc-area]');
        if (!(area instanceof HTMLInputElement)) return false;
        let canonical = new Intl.NumberFormat('en-US', { useGrouping: false, maximumSignificantDigits: 12 }).format(net);
        if (this.#parseArea(canonical).error === 'ambiguous') canonical += '0';
        area.value = canonical;
        const output = group.querySelector('[data-wall-net]');
        if (output instanceof HTMLElement) {
          const numbers = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { maximumSignificantDigits: 12 });
          output.textContent = (group.dataset.netMessage || '').replaceAll('[area]', numbers.format(Number(canonical)));
          output.hidden = false;
        }
        return true;
      }

      #openAmountHelp(card) {
        const help = card?.querySelector('.mw-paint-amount-help');
        if (!(help instanceof HTMLDetailsElement)) return;
        help.open = true;
        const summary = help.querySelector(':scope > summary');
        if (!(summary instanceof HTMLElement)) return;
        this.#focusAmountTarget(summary, true);
      }

      #focusAmountTarget(target, alignStart = false) {
        if (!(target instanceof HTMLElement)) return;
        target.focus({ preventScroll: true });
        const body = this.#activeDialog?.querySelector('[data-dialog-body]');
        if (body instanceof HTMLElement) {
          const bounds = body.getBoundingClientRect();
          const position = target.getBoundingClientRect();
          if (alignStart || position.top < bounds.top + 12 || position.bottom > bounds.bottom - 12) body.scrollTo({ top: body.scrollTop + position.top - bounds.top - 16, behavior: 'instant' });
        } else target.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      }

      #syncQuickChoices(group) {
        const input = group.querySelector('[data-ral-code]');
        if (!(input instanceof HTMLInputElement)) return;
        const match = /^(?:RAL\s*)?(\d{4})$/i.exec(input.value.trim());
        const code = match ? `RAL ${match[1]}` : '';
        for (const quick of group.querySelectorAll('[data-quick-ral]')) {
          if (quick instanceof HTMLInputElement) quick.checked = quick.value === code;
        }
      }

      #storePlan(card) {
        const inputs = [...this.querySelectorAll('[data-save-colour], [data-save-plan]')];
        if (inputs.length === 0) return;
        let values = {};
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.dataset.storageKey) || '{}');
          if (saved && typeof saved === 'object' && !Array.isArray(saved)) values = { ...saved };
        } catch {}
        for (const input of inputs) {
          if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) continue;
          if (input instanceof HTMLInputElement && input.type === 'radio' && !input.checked) continue;
          values[input.dataset.storageName || input.name] = input.value;
        }
        try { sessionStorage.setItem(this.dataset.storageKey, JSON.stringify(values)); } catch {}
        if (card instanceof HTMLElement) {
          this.#updateSelectionSummary(card);
          this.#updateProductLink(card);
        } else this.#updateSelectionSummaries();
      }

      #updateSelectionSummaries() {
        for (const card of this.querySelectorAll('.mw-paint-card')) {
          this.#updateSelectionSummary(card);
          this.#updateProductLink(card);
        }
      }

      #clearSelectionAnnouncements() {
        for (const timer of this.#selectionTimers.values()) clearTimeout(timer);
        this.#selectionTimers.clear();
      }

      #announceSelection(card) {
        if (!(card instanceof HTMLElement) || !card.isConnected) return;
        const value = card.querySelector('[data-selection-value]');
        const announcement = card.querySelector('[data-selection-announcement]');
        if (!(value instanceof HTMLElement) || !(announcement instanceof HTMLElement)) return;
        if (announcement.textContent !== value.textContent) announcement.textContent = value.textContent;
      }

      #queueSelectionAnnouncement(card, immediate) {
        if (!(card instanceof HTMLElement)) return;
        clearTimeout(this.#selectionTimers.get(card));
        this.#selectionTimers.delete(card);
        if (immediate) {
          this.#announceSelection(card);
          return;
        }
        const timer = setTimeout(() => {
          this.#selectionTimers.delete(card);
          this.#announceSelection(card);
        }, 500);
        this.#selectionTimers.set(card, timer);
      }

      #updatePackagePrice(card) {
        const panel = card.querySelector('[data-package-price-panel]');
        const size = card.querySelector('[data-package-size]');
        if (!(panel instanceof HTMLElement) || !(size instanceof HTMLSelectElement)) return '';
        const option = size.selectedOptions[0];
        const cents = Number(option?.dataset.packagePrice || '');
        const money = option?.dataset.packagePriceLabel?.trim() || '';
        const known = Number.isSafeInteger(cents) && cents > 0 && money !== '';
        const selectedPrice = known ? money : panel.dataset.pricePending || '';
        const value = panel.querySelector('[data-package-price-value]');
        if (value instanceof HTMLElement && value.textContent !== selectedPrice) value.textContent = selectedPrice;
        const tax = panel.querySelector('[data-package-tax]');
        if (tax instanceof HTMLElement) tax.hidden = !(known && panel.dataset.taxIncluded === 'true');
        const unit = panel.querySelector('[data-package-unit-value]');
        if (unit instanceof HTMLElement) {
          const unitMoney = known ? option?.dataset.unitPriceLabel?.trim() || '' : '';
          const unitText = unitMoney ? (panel.dataset.unitTemplate || '').replaceAll('[price]', unitMoney) : '';
          if (unit.textContent !== unitText) unit.textContent = unitText;
          unit.hidden = !unitText;
        }
        return selectedPrice;
      }

      #updateSelectionSummary(card) {
        if (!(card instanceof HTMLElement)) return;
        const selectedPrice = this.#updatePackagePrice(card);
        const summary = card.querySelector('[data-selection-summary]');
        const value = summary?.querySelector('[data-selection-value]');
        if (!(summary instanceof HTMLElement) || !(value instanceof HTMLElement)) return;
        const size = card.querySelector('[data-package-size]');
        const volume = size instanceof HTMLSelectElement ? size.selectedOptions[0]?.textContent?.trim() : '';
        let colour = summary.dataset.fixedColour || '';
        const group = card.querySelector('.mw-paint-colour');
        if (!colour && group instanceof HTMLElement) {
          const mode = group.querySelector('.mw-paint-colour__tabs input:checked');
          if (mode instanceof HTMLInputElement && mode.value === 'ral') {
            const input = group.querySelector('[data-ral-code]');
            if (input instanceof HTMLInputElement) {
              const match = /^(?:RAL\s*)?(\d{4})$/i.exec(input.value.trim());
              colour = match ? `RAL ${match[1]}` : input.value.trim();
            }
          } else {
            const brand = group.querySelector('input[name^="colour-brand-"]');
            const name = group.querySelector('[data-colour-name]');
            const brandValue = brand instanceof HTMLInputElement ? brand.value.trim() : '';
            const nameValue = name instanceof HTMLInputElement ? name.value.trim() : '';
            colour = [brandValue, nameValue].filter(Boolean).join(' · ');
          }
        }
        const next = (summary.dataset.summaryTemplate || '').replaceAll('[volume]', volume || summary.dataset.emptyVolume || '').replaceAll('[colour]', colour || summary.dataset.emptyColour || '').replaceAll('[price]', selectedPrice);
        if (value.textContent !== next) value.textContent = next;
      }

      #updateAdviceLink(card) {
        const links = card.querySelectorAll('[data-advice-link]');
        if (links.length === 0) return;
        const params = new URLSearchParams();
        const product = card.dataset.productHandle?.trim() || '';
        if (product && product.length <= 255 && !/[\u0000-\u001f\u007f]/.test(product)) params.set('product', product);
        const size = card.querySelector('[data-package-size]');
        if (size instanceof HTMLSelectElement && ['2.5', '5', '10'].includes(size.value)) params.set('volume', size.value);
        const group = card.querySelector('.mw-paint-colour');
        const modeInput = group?.querySelector('.mw-paint-colour__tabs input:checked');
        const mode = card.dataset.colourMode === 'white' ? 'white' : group?.dataset.colourMode === 'request' || modeInput instanceof HTMLInputElement && modeInput.value === 'other' ? 'other' : 'ral';
        params.set('mode', mode);
        if (mode === 'ral') {
          const input = group?.querySelector('[data-ral-code]');
          const match = input instanceof HTMLInputElement ? /^(?:RAL\s*)?(\d{4})$/i.exec(input.value.trim()) : null;
          if (match) params.set('ral', match[1]);
        } else if (mode === 'other') {
          for (const [key, selector, max] of [['brand', 'input[name^="colour-brand-"]', 80], ['colour', '[data-colour-name]', 120]]) {
            const input = group?.querySelector(selector);
            const value = input instanceof HTMLInputElement ? input.value.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, max) : '';
            if (value) params.set(key, value);
          }
        }
        for (const link of links) {
          if (!(link instanceof HTMLAnchorElement)) continue;
          try {
            const url = new URL(link.dataset.contactUrl || '/pages/contact', window.location.origin);
            if (url.origin !== window.location.origin) continue;
            url.search = params.toString();
            url.hash = '';
            link.href = url.href;
          } catch {}
        }
      }

      #updateProductLink(card) {
        if (!(card instanceof HTMLElement)) return;
        this.#updateAdviceLink(card);
        for (const link of card.querySelectorAll('[data-product-link]')) {
          if (!(link instanceof HTMLAnchorElement) || !link.dataset.productUrl) continue;
          const url = new URL(link.dataset.productUrl, window.location.origin);
          if (url.origin !== window.location.origin) continue;
          for (const key of ['volume', 'mode', 'ral', 'brand', 'colour']) url.searchParams.delete(key);
          const size = card.querySelector('[data-package-size]');
          if (size instanceof HTMLSelectElement && ['2.5', '5', '10'].includes(size.value)) url.searchParams.set('volume', size.value);
          const group = card.querySelector('.mw-paint-colour');
          if (!(group instanceof HTMLElement)) url.searchParams.set('mode', 'white');
          else {
            const mode = group.querySelector('.mw-paint-colour__tabs input:checked');
            if (mode instanceof HTMLInputElement && mode.value === 'ral') {
              url.searchParams.set('mode', 'ral');
              const input = group.querySelector('[data-ral-code]');
              const match = input instanceof HTMLInputElement ? /^(?:RAL\s*)?(\d{4})$/i.exec(input.value.trim()) : null;
              if (match) url.searchParams.set('ral', match[1]);
            } else {
              url.searchParams.set('mode', 'other');
              const brand = group.querySelector('input[name^="colour-brand-"]');
              const colour = group.querySelector('[data-colour-name]');
              if (brand instanceof HTMLInputElement && brand.value.trim()) url.searchParams.set('brand', brand.value.trim().slice(0, 80));
              if (colour instanceof HTMLInputElement && colour.value.trim()) url.searchParams.set('colour', colour.value.trim().slice(0, 120));
            }
          }
          link.href = url.href;
        }
      }

      #handleInput = (event) => {
        let input = event.target;
        if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;
        const wallGroup = input.closest('[data-calculator]');
        if (wallGroup instanceof HTMLElement && input.matches('[data-wall-length], [data-wall-height]')) {
          this.#syncWallState(wallGroup);
          this.#clearCalculation(wallGroup);
          this.#storePlan(input.closest('.mw-paint-card'));
          return;
        }
        const quickChoice = input.matches('[data-quick-ral]');
        if (quickChoice) {
          const field = input.closest('.mw-paint-colour')?.querySelector('[data-ral-code]');
          if (!(field instanceof HTMLInputElement)) return;
          field.value = input.value;
          input = field;
        }
        if (input.closest('.mw-assortment__filter')) {
          this.#updateFilterStatus();
          return;
        }
        if (!input.matches('[data-save-colour], [data-save-plan]')) return;
        const card = input.closest('.mw-paint-card');
        this.#storePlan(card);
        if (input.matches('[data-save-colour], [data-package-size]')) {
          const immediate = quickChoice || event.type === 'change' || input instanceof HTMLSelectElement || input.type === 'radio';
          this.#queueSelectionAnnouncement(card, immediate);
        }
        const group = input.closest('[data-calculator], .mw-paint-colour');
        if (!group) return;
        if (group.matches('[data-calculator]')) this.#clearCalculation(group);
        this.#syncQuickChoices(group);
        for (const invalid of group.querySelectorAll('[aria-invalid]')) invalid.removeAttribute('aria-invalid');
        const status = group.querySelector('[data-calc-status], [data-colour-status]');
        if (status instanceof HTMLElement) {
          status.textContent = '';
          delete status.dataset.state;
        }
      };

      #updateFilterStatus() {
        const selected = this.querySelector('.mw-assortment__filter input:checked');
        const filter = selected instanceof HTMLInputElement ? selected.value : 'all';
        let count = 0;
        for (const card of this.querySelectorAll('.mw-paint-card')) {
          if (card instanceof HTMLElement && (filter === 'all' || card.dataset[filter] === 'true')) count += 1;
        }
        const status = this.querySelector('[data-filter-status]');
        if (status instanceof HTMLElement) status.textContent = (status.dataset.countTemplate || '').replaceAll('[count]', String(count));
        const empty = this.querySelector('[data-filter-empty]');
        if (empty instanceof HTMLElement) empty.hidden = count > 0;
      }

      #handlePageHide = (event) => {
        this.#cancelFragmentNavigation(event);
        this.#closeProduct(false, false);
      };

      #cancelFragmentNavigation = (event) => {
        this.#fragmentRequest += 1;
        if (this.#fragmentFrame !== undefined) cancelAnimationFrame(this.#fragmentFrame);
        this.#fragmentFrame = undefined;
        if (event?.type === 'pagehide') {
          this.#fragmentTransition = undefined;
          this.#fragmentHandledHash = undefined;
          this.#fragmentInterrupted = false;
        } else if (event) {
          this.#fragmentInterrupted = true;
        }
      };

      #captureFragmentTransition = (event) => {
        this.#fragmentTransition = event.viewTransition?.finished;
        if (this.#fragmentTransition && !this.#fragmentInterrupted) {
          this.#fragmentHandledHash = undefined;
          this.#scheduleFragmentNavigation();
        }
      };

      #handleFragmentNavigation = (event) => {
        if (event.type === 'pageshow' && this.#fragmentInterrupted) return;
        this.#fragmentInterrupted = false;
        this.#fragmentHandledHash = undefined;
        this.#scheduleFragmentNavigation();
      };

      #scheduleFragmentNavigation() {
        this.#cancelFragmentNavigation();
        const hash = window.location.hash;
        const signal = this.#controller?.signal;
        if (!signal || document.readyState !== 'complete' || this.#fragmentInterrupted || this.#fragmentHandledHash === hash) return;
        if (hash !== '#kleurkeuze' && !hash.startsWith('#verf-')) return;
        const request = this.#fragmentRequest;
        const current = () => this.isConnected && !signal.aborted && request === this.#fragmentRequest && window.location.hash === hash;
        this.#fragmentFrame = requestAnimationFrame(() => {
          if (!current()) return;
          this.#fragmentFrame = requestAnimationFrame(() => {
            this.#fragmentFrame = undefined;
            if (!current()) return;
            const transition = this.#fragmentTransition || document.activeViewTransition?.finished;
            const queueCommit = () => {
              if (!current()) return;
              this.#fragmentFrame = requestAnimationFrame(() => {
                this.#fragmentFrame = undefined;
                if (!current()) return;
                this.#fragmentHandledHash = hash;
                this.#openFragment();
              });
            };
            Promise.resolve(transition).then(queueCommit, queueCommit);
          });
        });
      }

      #openFragment = () => {
        if (window.location.hash === '#kleurkeuze') {
          this.#openColourFragment();
          return;
        }
        if (!window.location.hash.startsWith('#verf-')) return;
        let targetId;
        try { targetId = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
        const card = [...this.querySelectorAll('.mw-paint-card')].find((item) => item instanceof HTMLElement && item.dataset.productHandle && item.id === targetId && targetId === `verf-${item.dataset.productHandle}`);
        if (!(card instanceof HTMLElement)) return;
        const selected = this.querySelector('.mw-assortment__filter input:checked');
        if (selected instanceof HTMLInputElement && selected.value !== 'all' && card.dataset[selected.value] !== 'true') {
          const allProducts = this.querySelector('.mw-assortment__filter input[value="all"]');
          if (allProducts instanceof HTMLInputElement) allProducts.checked = true;
          this.#updateFilterStatus();
        }
        if (this.#followProductPage(card)) return;
        this.#openProduct(card);
        this.#syncMediaControls();
      };

      #openColourFragment = () => {
        if (window.location.hash !== '#kleurkeuze') return;
        const colour = this.querySelector('#kleurkeuze');
        if (!(colour instanceof HTMLElement)) {
          const card = [...this.querySelectorAll('.mw-paint-card')].find((item) => item instanceof HTMLElement && item.dataset.colourMode !== 'white' && item.querySelector('[data-page-link]'));
          this.#followProductPage(card, 'kleurkeuze');
          return;
        }
        const allProducts = this.querySelector('.mw-assortment__filter input[value="all"]');
        if (allProducts instanceof HTMLInputElement) allProducts.checked = true;
        this.#updateFilterStatus();
        const card = colour.closest('.mw-paint-card');
        if (this.#followProductPage(card, 'kleurkeuze')) return;
        const dialog = this.#openProduct(card);
        if (dialog instanceof HTMLDialogElement) this.#setProductView(dialog, 'configuration');
        colour.setAttribute('tabindex', '-1');
        colour.focus({ preventScroll: true });
        if (dialog instanceof HTMLDialogElement) {
          const body = dialog.querySelector('[data-dialog-body]');
          if (body instanceof HTMLElement) body.scrollTo({ top: body.scrollTop + colour.getBoundingClientRect().top - body.getBoundingClientRect().top - 16, behavior: 'instant' });
        } else colour.scrollIntoView({ block: 'start' });
      };

      #setFeedback(group, selector, message, invalidInput) {
        const status = group.querySelector(selector);
        if (!(status instanceof HTMLElement)) return;
        for (const invalid of group.querySelectorAll('[aria-invalid]')) invalid.removeAttribute('aria-invalid');
        status.dataset.state = invalidInput ? 'error' : 'success';
        status.textContent = message;
        if (invalidInput instanceof HTMLElement) {
          invalidInput.setAttribute('aria-invalid', 'true');
          invalidInput.focus();
        }
      }

      #roundLitres(area, layers, coverage) {
        const tenths = area * layers * 10 / coverage;
        const nearest = Math.round(tenths);
        const tolerance = Number.EPSILON * Math.max(1, Math.abs(tenths)) * 4;
        const normalized = Math.abs(tenths - nearest) <= tolerance ? nearest : tenths;
        return Math.max(0.1, Math.ceil(normalized) / 10);
      }

      #packageIndication(group, liters, numbers) {
        const select = group.closest('.mw-paint-card')?.querySelector('[data-package-size]');
        if (!(select instanceof HTMLSelectElement)) return '';
        const sizes = new Set([...select.options].map((option) => Number(option.value)));
        if (sizes.size !== 3 || ![2.5, 5, 10].every((size) => sizes.has(size))) return '';
        let units = Math.ceil(liters * 10 / 25);
        const total = units * 2.5;
        const packages = [];
        for (const [unitCount, size] of [[4, 10], [2, 5], [1, 2.5]]) {
          const count = Math.floor(units / unitCount);
          if (count === 0) continue;
          units %= unitCount;
          packages.push((group.dataset.packageItem || '').replaceAll('[count]', numbers.format(count)).replaceAll('[liters]', numbers.format(size)));
        }
        return (group.dataset.packageMessage || '').replaceAll('[packages]', packages.join(' + ')).replaceAll('[total]', numbers.format(total));
      }

      #parseArea(rawValue) {
        const rawArea = rawValue.trim();
        if (/^[1-9]\d{0,2}[.,]\d{3}$/.test(rawArea)) return { value: NaN, error: 'ambiguous' };
        const area = /^(?:\d+(?:[.,]\d+)?|[.,]\d+)$/.test(rawArea) ? Number(rawArea.replace(',', '.')) : NaN;
        if (!Number.isFinite(area) || area <= 0) return { value: NaN, error: 'invalid' };
        return { value: area, error: '' };
      }

      #calculate(group) {
        this.#clearCalculation(group);
        if (!this.#prepareWallArea(group)) return;
        const areaInput = group.querySelector('[data-calc-area]');
        const layersInput = group.querySelector('[data-calc-layers]');
        if (!(areaInput instanceof HTMLInputElement) || !(layersInput instanceof HTMLSelectElement)) return;
        const parsedArea = this.#parseArea(areaInput.value);
        if (parsedArea.error) {
          const message = parsedArea.error === 'ambiguous' ? group.dataset.errorAmbiguous : group.dataset.errorArea;
          this.#setFeedback(group, '[data-calc-status]', message || '', areaInput);
          return;
        }
        const area = parsedArea.value;
        const layers = Number(layersInput.value);
        const minimumLayers = Number(group.dataset.minimumLayers);
        if (!Number.isInteger(layers) || layers < minimumLayers || layers > 3) {
          this.#setFeedback(group, '[data-calc-status]', group.dataset.errorLayers || '', layersInput);
          return;
        }
        const coverage = Number(group.dataset.coverage);
        const maximumCoverage = Math.max(coverage, Number(group.dataset.coverageMax) || coverage);
        if (!Number.isFinite(coverage) || coverage <= 0 || !Number.isFinite(maximumCoverage)) return;
        const liters = this.#roundLitres(area, layers, coverage);
        const lower = this.#roundLitres(area, layers, maximumCoverage);
        if (!Number.isFinite(liters) || !Number.isFinite(lower)) {
          this.#setFeedback(group, '[data-calc-status]', group.dataset.errorArea || '', areaInput);
          return;
        }
        const numbers = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { maximumFractionDigits: 6 });
        const volumes = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { maximumFractionDigits: 1 });
        const template = lower < liters ? group.dataset.rangeMessage : group.dataset.resultMessage;
        const message = (template || '').replaceAll('[lower]', volumes.format(lower)).replaceAll('[liters]', volumes.format(liters)).replaceAll('[area]', numbers.format(area)).replaceAll('[layers]', String(layers)).replaceAll('[coverage]', numbers.format(coverage));
        const packageMessage = this.#packageIndication(group, liters, numbers);
        this.#setFeedback(group, '[data-calc-status]', packageMessage ? `${message} ${packageMessage}` : message);
        const body = this.#activeDialog?.querySelector('[data-dialog-body]');
        const result = group.querySelector('[data-calc-status]');
        if (body instanceof HTMLElement && result instanceof HTMLElement && body.contains(group)) {
          const overflow = result.getBoundingClientRect().bottom - body.getBoundingClientRect().bottom + 16;
          if (overflow > 0) body.scrollTo({ top: body.scrollTop + overflow, behavior: 'instant' });
        }
        this.#storePlan();
      }

      #checkColour(group) {
        const modeInput = group.querySelector('input[type="radio"]:checked');
        const isRal = group.dataset.colourMode !== 'request' && modeInput instanceof HTMLInputElement && modeInput.value === 'ral';
        if (isRal) {
          const input = group.querySelector('[data-ral-code]');
          if (!(input instanceof HTMLInputElement)) return;
          const match = /^(?:RAL\s*)?(\d{4})$/i.exec(input.value.trim());
          if (!match) {
            this.#setFeedback(group, '[data-colour-status]', group.dataset.errorRal || '', input);
            return;
          }
          input.value = `RAL ${match[1]}`;
          this.#syncQuickChoices(group);
          this.#setFeedback(group, '[data-colour-status]', (group.dataset.ralMessage || '').replaceAll('[code]', input.value));
        } else {
          const input = group.querySelector('[data-colour-name]');
          if (!(input instanceof HTMLInputElement)) return;
          if (!input.value.trim()) {
            this.#setFeedback(group, '[data-colour-status]', group.dataset.errorOther || '', input);
            return;
          }
          this.#setFeedback(group, '[data-colour-status]', group.dataset.otherMessage || '');
        }
        this.#storePlan();
      }

      #syncMediaControls() {
        for (const card of this.querySelectorAll('.mw-paint-card')) {
          const details = card.querySelector(':scope > .mw-paint-card__details');
          if (details instanceof HTMLDetailsElement) {
            const dialog = card.querySelector(':scope > [data-product-dialog]');
            const modalReady = dialog instanceof HTMLDialogElement && typeof dialog.showModal === 'function' && !this.#failedDialogs.has(dialog);
            const summary = details.querySelector(':scope > summary');
            if (summary instanceof HTMLElement) {
              if (modalReady) {
                summary.setAttribute('aria-controls', dialog.id);
                summary.setAttribute('aria-haspopup', 'dialog');
              } else {
                summary.removeAttribute('aria-controls');
                summary.removeAttribute('aria-haspopup');
              }
            }
            for (const opener of card.querySelectorAll('[data-open-product]')) {
              if (!(opener instanceof HTMLButtonElement)) continue;
              opener.disabled = false;
              opener.setAttribute('aria-expanded', String(details.open));
              opener.setAttribute('aria-controls', modalReady ? dialog.id : details.id);
              if (modalReady) opener.setAttribute('aria-haspopup', 'dialog');
              else opener.removeAttribute('aria-haspopup');
            }
          }
          const toggle = card.querySelector('[data-toggle-atmosphere]');
          if (toggle instanceof HTMLButtonElement) this.#setAtmosphere(card, toggle, card.dataset.atmosphereActive === 'true');
        }
      }

      #handleDetailsToggle = (event) => {
        const details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('mw-paint-card__details')) return;
        const card = details.closest('.mw-paint-card');
        if (!(card instanceof HTMLElement)) return;
        for (const opener of card.querySelectorAll('[data-open-product]')) opener.setAttribute('aria-expanded', String(details.open));
      };

      #setAtmosphere(card, toggle, active) {
        card.dataset.atmosphereActive = String(active);
        toggle.setAttribute('aria-label', (active ? toggle.dataset.hideAccessibleLabel : toggle.dataset.showAccessibleLabel) || '');
        const label = toggle.querySelector('[data-atmosphere-toggle-label]');
        if (label instanceof HTMLElement) label.textContent = (active ? toggle.dataset.hideLabel : toggle.dataset.showLabel) || '';
      }

      #setProductView(dialog, view, focusTab = false) {
        if (!(dialog instanceof HTMLDialogElement) || !['information', 'configuration'].includes(view)) return;
        const tabs = [...dialog.querySelectorAll('[data-product-tab]')];
        const selected = tabs.find((tab) => tab instanceof HTMLButtonElement && tab.dataset.productTab === view);
        if (!(selected instanceof HTMLButtonElement)) return;
        for (const tab of tabs) {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('tabindex', active ? '0' : '-1');
        }
        for (const panel of dialog.querySelectorAll('[data-product-panel]')) {
          if (!(panel instanceof HTMLElement)) continue;
          const tab = tabs.find((item) => item.dataset.productTab === panel.dataset.productPanel);
          panel.hidden = panel.dataset.productPanel !== view;
          panel.setAttribute('role', 'tabpanel');
          if (tab instanceof HTMLElement) panel.setAttribute('aria-labelledby', tab.id);
          if (panel.dataset.productPanel === 'information') panel.setAttribute('tabindex', '0');
        }
        const body = dialog.querySelector('[data-dialog-body]');
        if (body instanceof HTMLElement) body.scrollTop = 0;
        if (focusTab) selected.focus({ preventScroll: true });
      }

      #resetProductView(dialog, content) {
        if (content instanceof HTMLElement) {
          for (const panel of content.querySelectorAll('[data-product-panel]')) {
            panel.hidden = false;
            panel.removeAttribute('role');
            panel.removeAttribute('aria-labelledby');
            panel.removeAttribute('tabindex');
          }
        }
        for (const tab of dialog.querySelectorAll('[data-product-tab]')) {
          const active = tab.dataset.productTab === 'information';
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('tabindex', active ? '0' : '-1');
        }
      }

      #followProductPage(card, fragment = '') {
        if (this.dataset.pageMode === 'true' || !(card instanceof HTMLElement)) return false;
        const link = card.querySelector('[data-page-link]');
        if (!(link instanceof HTMLAnchorElement) || !link.dataset.pageUrl) return false;
        const url = new URL(link.dataset.pageUrl, window.location.origin);
        if (url.origin !== window.location.origin) return false;
        url.search = '';
        url.hash = fragment;
        window.location.replace(url.href);
        return true;
      }

      #openProduct(card, trigger) {
        if (!(card instanceof HTMLElement)) return;
        if (this.#followProductPage(card)) return;
        const details = card.querySelector(':scope > .mw-paint-card__details');
        if (!(details instanceof HTMLDetailsElement)) return;
        const dialog = card.querySelector(':scope > [data-product-dialog]');
        const body = dialog?.querySelector('[data-dialog-body]');
        const content = card.querySelector('.mw-paint-card__detail-content');
        const summary = details.querySelector(':scope > summary');
        if (!(dialog instanceof HTMLDialogElement) || typeof dialog.showModal !== 'function' || this.#failedDialogs.has(dialog) || !(body instanceof HTMLElement) || !(content instanceof HTMLElement)) {
          details.open = true;
          summary?.focus({ preventScroll: true });
          details.scrollIntoView({ block: 'start', behavior: 'instant' });
          return;
        }
        if (this.#activeDialog === dialog && dialog.open) {
          this.#setProductView(dialog, 'information');
          dialog.querySelector('[data-dialog-title]')?.focus({ preventScroll: true });
          return dialog;
        }
        this.#closeProduct(false);
        this.#dialogScrollTop = getScrollTop();
        this.#activeDialog = dialog;
        this.#dialogDetails = details;
        this.#dialogContent = content;
        this.#dialogReturnFocus = trigger instanceof HTMLElement ? trigger : summary;
        card.dataset.modalOpen = 'true';
        body.append(content);
        const technical = content.querySelector('[data-product-technical]');
        if (technical instanceof HTMLDetailsElement) technical.open = true;
        this.#setProductView(dialog, 'information');
        details.open = true;
        dialog.returnValue = '';
        lockScroll(dialog);
        try {
          dialog.showModal();
          body.scrollTop = 0;
          dialog.querySelector('[data-dialog-title]')?.focus({ preventScroll: true });
          scrollTo({ top: this.#dialogScrollTop, behavior: 'instant' });
          this.#syncMediaControls();
          return dialog;
        } catch {
          this.#failedDialogs.add(dialog);
          this.#closeProduct(false);
          details.open = true;
          summary?.focus({ preventScroll: true });
          return;
        }
      }

      #closeProduct(restoreFocus = true, restoreScroll = true) {
        const dialog = this.#activeDialog;
        if (!(dialog instanceof HTMLDialogElement)) return;
        const details = this.#dialogDetails;
        const content = this.#dialogContent;
        const returnFocus = this.#dialogReturnFocus;
        const previousScrollTop = this.#dialogScrollTop;
        const card = dialog.closest('.mw-paint-card');
        this.#activeDialog = undefined;
        this.#dialogDetails = undefined;
        this.#dialogContent = undefined;
        this.#dialogReturnFocus = undefined;
        if (dialog.open) dialog.close();
        this.#resetProductView(dialog, content);
        if (details instanceof HTMLDetailsElement) {
          details.open = false;
          if (content instanceof HTMLElement) {
            for (const nested of content.querySelectorAll('details[open]')) nested.open = false;
            details.append(content);
          }
        }
        if (card instanceof HTMLElement) delete card.dataset.modalOpen;
        unlockScroll(dialog);
        this.#syncMediaControls();
        if (restoreFocus && this.isConnected && returnFocus instanceof HTMLElement && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
        if (restoreScroll && this.isConnected) scrollTo({ top: previousScrollTop, behavior: 'instant' });
      }

      #handleDialogClose = (event) => {
        if (event.target === this.#activeDialog) this.#closeProduct();
      };

      #handleClick = (event) => {
        if (!(event.target instanceof Element)) return;
        if (this.#activeDialog && isClickedOutside(event, this.#activeDialog)) {
          this.#closeProduct();
          return;
        }
        const tab = event.target.closest('[data-product-tab]');
        if (tab instanceof HTMLButtonElement) {
          this.#setProductView(tab.closest('[data-product-dialog]'), tab.dataset.productTab, true);
          return;
        }
        const configure = event.target.closest('[data-show-product-view]');
        if (configure instanceof HTMLButtonElement) {
          const dialog = configure.closest('[data-product-dialog]');
          this.#setProductView(dialog, 'configuration');
          dialog?.querySelector('[data-package-size]')?.focus({ preventScroll: true });
          return;
        }
        const jump = event.target.closest('[data-open-amount-help]');
        if (jump instanceof HTMLButtonElement) { this.#openAmountHelp(jump.closest('.mw-paint-card')); return; }
        const addWall = event.target.closest('[data-add-wall]');
        const removeWall = event.target.closest('[data-remove-wall]');
        if (addWall instanceof HTMLButtonElement || removeWall instanceof HTMLButtonElement) {
          const group = (addWall || removeWall).closest('[data-calculator]');
          if (!(group instanceof HTMLElement)) return;
          let focus;
          if (addWall) focus = this.#appendWallRow(group)?.querySelector('[data-wall-length]');
          else {
            const rows = [...group.querySelectorAll('[data-wall-row]')];
            const row = removeWall.closest('[data-wall-row]');
            if (rows.length <= 1 || !(row instanceof HTMLElement)) return;
            const index = rows.indexOf(row);
            focus = (rows[index + 1] || rows[index - 1])?.querySelector('[data-wall-length]');
            row.remove();
          }
          this.#syncWallState(group);
          this.#clearCalculation(group);
          this.#storePlan(group.closest('.mw-paint-card'));
          this.#focusAmountTarget(focus);
          return;
        }
        const summary = event.target.closest('.mw-paint-card__details > summary');
        if (summary instanceof HTMLElement) {
          const card = summary.closest('.mw-paint-card');
          const dialog = card?.querySelector(':scope > [data-product-dialog]');
          if (dialog instanceof HTMLDialogElement && typeof dialog.showModal === 'function' && !this.#failedDialogs.has(dialog)) {
            event.preventDefault();
            this.#openProduct(card, summary);
            return;
          }
        }
        const atmosphere = event.target.closest('[data-toggle-atmosphere]');
        if (atmosphere instanceof HTMLButtonElement) {
          const card = atmosphere.closest('.mw-paint-card');
          if (card instanceof HTMLElement) this.#setAtmosphere(card, atmosphere, card.dataset.atmosphereActive !== 'true');
          return;
        }
        const opener = event.target.closest('[data-open-product]');
        if (opener instanceof HTMLButtonElement) {
          this.#openProduct(opener.closest('.mw-paint-card'), opener);
          return;
        }
        const productLink = event.target.closest('[data-product-link], [data-page-link]');
        if (productLink) {
          this.#storePlan(productLink.closest('.mw-paint-card'));
          return;
        }
        const calculate = event.target.closest('[data-calculate]');
        if (calculate) {
          const group = calculate.closest('[data-calculator]');
          if (group instanceof HTMLElement) this.#calculate(group);
          return;
        }
        const check = event.target.closest('[data-check-colour]');
        if (check) {
          const group = check.closest('.mw-paint-colour');
          if (group instanceof HTMLElement) this.#checkColour(group);
          return;
        }
        const close = event.target.closest('[data-close-product]');
        if (!close) return;
        if (this.#activeDialog && this.#activeDialog.contains(close)) {
          this.#closeProduct();
          return;
        }
        const details = close.closest('.mw-paint-card__details');
        if (!(details instanceof HTMLDetailsElement)) return;
        details.open = false;
        details.querySelector('summary')?.focus();
      };

      #handleKeydown = (event) => {
        if (!(event.target instanceof Element)) return;
        const tab = event.target.closest('[data-product-tab]');
        if (tab instanceof HTMLButtonElement && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          const dialog = tab.closest('[data-product-dialog]');
          if (!(dialog instanceof HTMLDialogElement)) return;
          const tabs = [...dialog.querySelectorAll('[data-product-tab]')].filter((item) => item instanceof HTMLButtonElement);
          const current = tabs.indexOf(tab);
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          if (tabs[index]) {
            event.preventDefault();
            this.#setProductView(dialog, tabs[index].dataset.productTab, true);
          }
          return;
        }
        if (event.key === 'Enter' && event.target.matches('[data-calc-area], [data-wall-length], [data-wall-height], [data-wall-deduction]')) {
          const group = event.target.closest('[data-calculator]');
          if (group instanceof HTMLElement) {
            event.preventDefault();
            this.#calculate(group);
          }
          return;
        }
        if (event.key !== 'Escape') return;
        if (this.dataset.pageMode === 'true' || this.#activeDialog?.contains(event.target)) return;
        const details = event.target.closest('details[open]');
        if (!(details instanceof HTMLDetailsElement)) return;
        details.open = false;
        details.querySelector('summary')?.focus();
        event.preventDefault();
      };
    }
    if (!customElements.get('mw-paint-assortment')) customElements.define('mw-paint-assortment', MwPaintAssortment);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muurverfwinkel-product"]) return;
  try {
    
  import('@theme/component').then(({ Component }) => {
    class MwNativeProduct extends Component {
      #controller;
      #variants = [];
      #messages = {};
      #started = false;

      connectedCallback() {
        super.connectedCallback();
        this.#initialize();
      }

      updatedCallback() {
        super.updatedCallback();
        this.#initialize();
      }

      disconnectedCallback() {
        this.#controller?.abort();
        super.disconnectedCallback();
      }

      #initialize() {
        this.#controller?.abort();
        this.#controller = new AbortController();
        const { signal } = this.#controller;
        try {
          this.#variants = JSON.parse(this.querySelector('[data-variant-data]')?.textContent || '[]');
          this.#messages = JSON.parse(this.querySelector('[data-product-messages]')?.textContent || '{}');
        } catch { return; }
        const form = this.querySelector('form');
        if (!(form instanceof HTMLFormElement)) return;
        const enhanced = this.querySelector('[data-enhanced]');
        if (enhanced instanceof HTMLElement) enhanced.hidden = false;
        const modes = this.querySelector('[data-mode-controls]');
        if (modes instanceof HTMLFieldSetElement) modes.disabled = false;
        const summary = this.querySelector('[data-selection]');
        if (summary instanceof HTMLElement) summary.hidden = false;
        this.#restore();
        this.#sync();
        this.#save();
        this.addEventListener('input', this.#change, { signal });
        this.addEventListener('change', this.#change, { signal });
        form.addEventListener('invalid', this.#save, { signal, capture: true });
        form.addEventListener('submit', this.#submit, { signal });
        this.#started = true;
      }

      #field(selector) {
        const field = this.querySelector(selector);
        return field instanceof HTMLInputElement || field instanceof HTMLSelectElement ? field : null;
      }

      #normalRal(value) {
        if (typeof value !== 'string') return '';
        const match = /^(?:RAL\s*)?(\d{4})$/i.exec(value.trim());
        return match ? `RAL ${match[1]}` : '';
      }

      #shortText(value, max) {
        return typeof value === 'string' && value.length <= max && !/[\u0000-\u001f\u007f]/.test(value) ? value.trim() : '';
      }

      #volume(value) {
        if (typeof value !== 'string') return '';
        const candidate = value.toLowerCase().replace('liter', '').trim().replace(',', '.');
        return ['2.5', '5', '10'].includes(candidate) ? candidate : '';
      }

      #setVolume(value) {
        const volume = this.#volume(value);
        const select = this.#field('[data-variant]');
        if (!volume || !(select instanceof HTMLSelectElement)) return;
        const option = [...select.options].find((item) => this.#volume(item.dataset.volume) === volume);
        if (option) select.value = option.value;
      }

      #mode() {
        if (this.dataset.isPrimer === 'true') return 'white';
        return this.querySelector('[data-mode]:checked')?.value === 'other' ? 'other' : 'ral';
      }

      #restore() {
        let saved = null;
        try { saved = JSON.parse(sessionStorage.getItem(`mw-product-config-${this.dataset.productId}`) || 'null'); } catch {}
        const ownState = saved && typeof saved === 'object' && !Array.isArray(saved);
        if (!ownState) saved = this.#homepageState();
        if (saved && typeof saved === 'object') {
          const select = this.#field('[data-variant]');
          if (select instanceof HTMLSelectElement && this.#variants.some((variant) => variant.id === saved.variant)) select.value = saved.variant;
          else this.#setVolume(saved.volume);
          const quantity = this.#field('[data-quantity]');
          if (quantity && /^\d{1,6}$/.test(String(saved.quantity || ''))) quantity.value = String(saved.quantity);
          this.#applyColour(saved, !ownState);
        }
        if (this.#started) return;
        const params = new URL(window.location.href).searchParams;
        const select = this.#field('[data-variant]');
        if (select instanceof HTMLSelectElement && this.#variants.some((variant) => variant.id === params.get('variant'))) select.value = params.get('variant');
        if (params.has('volume')) this.#setVolume(params.get('volume'));
        const colourHandoff = ['mode', 'ral', 'colour', 'brand'].some((key) => params.has(key));
        if (colourHandoff) {
          this.#applyColour({ mode: params.get('mode'), ral: params.get('ral'), brand: params.get('brand'), colour: params.get('colour') }, true, true);
        }
        if (colourHandoff || params.has('volume')) this.#updateUrl(true);
      }

      #homepageState() {
        if (!this.dataset.paintBlock) return null;
        try {
          const keys = [];
          for (let index = 0; index < sessionStorage.length; index += 1) {
            const key = sessionStorage.key(index);
            if (key?.startsWith('mw-paint-demo-')) keys.push(key);
          }
          for (const key of keys.reverse()) {
            const saved = JSON.parse(sessionStorage.getItem(key) || '{}');
            if (!saved || typeof saved !== 'object' || Array.isArray(saved)) continue;
            const block = this.dataset.paintBlock;
            const suffix = key.slice('mw-paint-demo-'.length);
            const state = {
              volume: saved[`plan-package-${block}`],
              mode: saved[`colour-mode-${block}-${suffix}`],
              ral: saved[`colour-ral-${block}`],
              brand: saved[`colour-brand-${block}`],
              colour: saved[`colour-name-${block}`]
            };
            if (state.volume || state.ral || state.colour) return state;
          }
        } catch {}
        return null;
      }

      #applyColour(state, strict = true, handoff = false) {
        if (this.dataset.isPrimer === 'true') return;
        let mode = state.mode === 'other' ? 'other' : state.mode === 'ral' ? 'ral' : null;
        if (handoff && !mode) {
          if (typeof state.ral === 'string') mode = 'ral';
          else if (typeof state.colour === 'string' || typeof state.brand === 'string') mode = 'other';
        }
        if (mode) {
          for (const radio of this.querySelectorAll('[data-mode]')) if (radio instanceof HTMLInputElement) radio.checked = radio.value === mode;
        }
        const ral = strict ? this.#normalRal(state.ral) : this.#shortText(state.ral, 12);
        const brand = this.#shortText(state.brand, 80);
        const colour = this.#shortText(state.colour, 120);
        const ralField = this.#field('[data-ral]');
        const brandField = this.#field('[data-brand]');
        const colourField = this.#field('[data-colour]');
        const activeMode = mode || this.#mode();
        if (ralField && (ral || handoff && activeMode === 'ral')) ralField.value = ral;
        if (brandField && (brand || handoff && activeMode === 'other')) brandField.value = brand;
        if (colourField && (colour || handoff && activeMode === 'other')) colourField.value = colour;
      }

      #change = (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
        if (target.matches('[data-quick-ral]')) {
          const ral = this.#field('[data-ral]');
          if (ral) ral.value = `RAL ${target.value}`;
        }
        if (target.matches('[data-ral]')) target.setCustomValidity('');
        this.#sync();
        this.#save();
        if (target.matches('[data-variant]')) this.#updateUrl();
      };

      #sync() {
        const select = this.#field('[data-variant]');
        const quantity = this.#field('[data-quantity]');
        const variant = this.#variants.find((item) => item.id === select?.value);
        const mode = this.#mode();
        for (const [selector, active] of [['[data-ral-fields]', mode === 'ral'], ['[data-other-fields]', mode === 'other']]) {
          const group = this.querySelector(selector);
          if (group instanceof HTMLFieldSetElement) { group.disabled = !active; group.hidden = !active; }
        }
        if (variant && quantity) {
          quantity.min = String(variant.min || 1);
          quantity.step = String(variant.step || 1);
          if (variant.max !== null && Number.isFinite(variant.max)) quantity.max = String(variant.max);
          else quantity.removeAttribute('max');
        }
        const price = this.querySelector('[data-price]');
        if (price instanceof HTMLElement) price.textContent = variant?.price > 0 ? variant.money : this.#messages.priceFollows;
        const tax = this.querySelector('[data-tax]');
        if (tax instanceof HTMLElement) tax.hidden = !(variant?.price > 0);
        const button = this.querySelector('[data-submit]');
        if (button instanceof HTMLButtonElement) {
          const enabled = this.dataset.purchasesEnabled === 'true' && variant?.available === true && variant.price > 0;
          button.disabled = !enabled;
          button.textContent = this.dataset.purchasesEnabled !== 'true' ? this.#messages.comingSoon : enabled ? this.#messages.add : this.#messages.unavailable;
        }
        const ral = this.#normalRal(this.#field('[data-ral]')?.value);
        for (const radio of this.querySelectorAll('[data-quick-ral]')) if (radio instanceof HTMLInputElement) radio.checked = ral === `RAL ${radio.value}`;
        const brand = this.#field('[data-brand]')?.value.trim() || '';
        const colour = this.#field('[data-colour]')?.value.trim() || '';
        const summaryColour = mode === 'white' ? this.#messages.fixedWhite : mode === 'ral' ? ral || this.#field('[data-ral]')?.value.trim() : [brand, colour].filter(Boolean).join(' · ');
        for (const [selector, value] of [
          ['[data-summary-volume]', variant?.title || ''],
          ['[data-summary-quantity]', quantity?.value || ''],
          ['[data-summary-colour]', summaryColour || this.#messages.colourEmpty]
        ]) {
          const output = this.querySelector(selector);
          if (output instanceof HTMLElement && output.textContent !== value) output.textContent = value;
        }
      }

      #save = () => {
        const select = this.#field('[data-variant]');
        const state = {
          variant: select?.value || '',
          quantity: this.#field('[data-quantity]')?.value || '',
          mode: this.#mode(),
          ral: this.#field('[data-ral]')?.value || '',
          brand: this.#field('[data-brand]')?.value || '',
          colour: this.#field('[data-colour]')?.value || ''
        };
        try { sessionStorage.setItem(`mw-product-config-${this.dataset.productId}`, JSON.stringify(state)); } catch {}
      };

      #updateUrl(consumeHandoff = false) {
        const variant = this.#field('[data-variant]')?.value;
        if (!this.#variants.some((item) => item.id === variant)) return;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant);
        url.searchParams.delete('volume');
        if (consumeHandoff) {
          for (const key of ['mode', 'ral', 'brand', 'colour']) url.searchParams.delete(key);
        }
        window.history.replaceState(window.history.state, '', url);
      }

      #submit = (event) => {
        this.#save();
        const select = this.#field('[data-variant]');
        const variant = this.#variants.find((item) => item.id === select?.value);
        if (this.dataset.purchasesEnabled !== 'true' || !variant?.available || !(variant.price > 0)) {
          event.preventDefault();
          const status = this.querySelector('[data-status]');
          if (status instanceof HTMLElement) status.textContent = this.#messages.closed;
          return;
        }
        const ral = this.#field('[data-ral]');
        if (this.#mode() === 'ral' && ral) {
          const value = this.#normalRal(ral.value);
          if (!value) {
            event.preventDefault();
            ral.setCustomValidity(this.#messages.ralError);
            ral.reportValidity();
            return;
          }
          ral.value = value;
        }
      };
    }
    class MwProductGallery extends Component {
      #controller;
      #activeView = 'product';

      connectedCallback() {
        super.connectedCallback();
        this.#initialize();
      }

      updatedCallback() {
        super.updatedCallback();
        this.#initialize();
      }

      disconnectedCallback() {
        this.#controller?.abort();
        super.disconnectedCallback();
      }

      #initialize() {
        this.#controller?.abort();
        this.#controller = new AbortController();
        const buttons = this.querySelector('[data-gallery-buttons]');
        if (buttons instanceof HTMLElement) buttons.hidden = false;
        this.#showView(this.#activeView);
        this.addEventListener('click', this.#handleClick, { signal: this.#controller.signal });
      }

      #handleClick = (event) => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-gallery-choice]');
        if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;
        const view = button.dataset.galleryChoice;
        if (view !== 'product' && view !== 'mood') return;
        this.#showView(view);
      };

      #showView(view) {
        if (view === 'mood' && !this.querySelector('[data-gallery-panel="mood"]')) view = 'product';
        this.#activeView = view;
        const stage = this.querySelector('[data-gallery-stage]');
        if (stage instanceof HTMLElement) stage.dataset.galleryView = view;
        for (const panel of this.querySelectorAll('[data-gallery-panel]')) {
          if (panel instanceof HTMLElement) panel.hidden = panel.dataset.galleryPanel !== view;
        }
        for (const caption of this.querySelectorAll('[data-gallery-caption]')) {
          if (caption instanceof HTMLElement) caption.hidden = caption.dataset.galleryCaption !== view;
        }
        for (const button of this.querySelectorAll('[data-gallery-choice]')) {
          if (button instanceof HTMLButtonElement) button.setAttribute('aria-pressed', String(button.dataset.galleryChoice === view));
        }
      }
    }

    if (!customElements.get('mw-native-product')) customElements.define('mw-native-product', MwNativeProduct);
    if (!customElements.get('mw-product-gallery')) customElements.define('mw-product-gallery', MwProductGallery);
  });

  } catch(e) { console.error(e); }
})();
})();
